import { Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

const CardAnnualRecoveryDetail = ({ total, is_after_validation }) => {
    return (
        <Wrapper>
            <Flex column>
                <Title content="Récupération annuelle" />
                <SubTitle
                    content={
                        is_after_validation
                            ? "Après validation"
                            : "Avant validation"
                    }
                />
            </Flex>
            <Flex>
                <Total content={total > 0 ? `+ ${total} h` : total + " h"} />
            </Flex>
        </Wrapper>
    );
};

export default CardAnnualRecoveryDetail;

const Total = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Brand-Foreground-2, #4f52b2);

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
`;

const SubTitle = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-2, #616161);

    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 120% */
`;

const Title = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const Wrapper = styled.div`
    display: flex;
    width: 231px;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-m-16, 16px);

    border-radius: 8px;
    background: var(
        --Light-theme-Rest-Background-Default-Background-3,
        #f0f0f0
    );
`;
